import React from "react";

const StoreSkeletonCard: React.FC = () => {
  return (
    // Mimics the .store-card container: horizontal flex layout, shadow, rounded corners
    <div className="shadow-md transition-shadow duration-300 rounded-xl overflow-hidden flex cursor-pointer hover:shadow-lg animate-pulse">
      
      {/* image-wrapper: fixed width of 120px, aspect-square for logo space */}
      <div className="relative w-[120px] h-[120px] bg-gray-200 flex-shrink-0">
        {/* Placeholder for the image area */}
      </div>

      {/* store-details: takes up remaining width, p-4 consistent with original padding */}
      <div className="p-4 bg-white flex flex-grow justify-between">
        <div className="store-details-content flex justify-between w-full">
          
          {/* Left side details */}
          <div className="flex flex-col justify-between">
            <div>
              {/* store-title placeholder */}
              <div className="h-5 bg-gray-200 rounded w-48 mb-2"></div>
            </div>
            
            {/* Rating/Reviews */}
            <div className="h-4 bg-gray-200 rounded w-32 mb-2"></div>
            
            {/* Total Active Products */}
            <div className="h-4 bg-gray-200 rounded w-40"></div>
          </div>
          
          {/* Right side stats and buttons container */}
          <div className="flex flex-col justify-between items-end min-w-[230px]">
            <div className="sold-units-container">
                {/* Sold Units label */}
                <div className="sold-units mb-2">
                <div className="h-4 bg-gray-200 rounded w-20 ml-auto"></div>
                </div>
                
                {/* stats-container */}
                <div className="stats-container flex justify-between text-xs text-center gap-5">
                {/* Weekly */}
                <div className="flex flex-col items-center gap-1">
                    <div className="h-4 bg-gray-200 rounded w-10"></div>
                    <div className="h-4 bg-gray-200 rounded w-10"></div>
                </div>
                {/* Monthly */}
                <div className="flex flex-col items-center gap-1">
                    <div className="h-4 bg-gray-200 rounded w-10"></div>
                    <div className="h-4 bg-gray-200 rounded w-10"></div>
                </div>
                {/* All Time */}
                <div className="flex flex-col items-center gap-1">
                    <div className="h-4 bg-gray-200 rounded w-10"></div>
                    <div className="h-4 bg-gray-200 rounded w-10"></div>
                </div>
                </div>
            </div>
            
            {/* store-quick-view-wrap (buttons) */}
            <div className="action-btns w-full mt-4">
                <div className="h-9 bg-gray-200 rounded-lg w-full"></div> {/* Primary Button Placeholder */}
                <div className="h-9 bg-gray-200 rounded-lg w-full mt-2"></div> {/* Secondary Button Placeholder */}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default StoreSkeletonCard;
